import React, { useEffect } from 'react'
import {
  Select,
  SelectItem,
  Button,
} from '@carbon/react';
import { IFileQueuerConfig } from './FileQueuer.model';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getWatchfolderEngineProfiles, getWatchfolderEngines, selectFileQueuerTagetConfigs, selectToken, selectWatchfolderEngineProfiles, selectWatchfolderEngines, setFileQueuerTagetConfigs } from '../../../AppSlice';
import Icon from '../../Icon/Icon';
import EngineConfigForm from '../watchfolder/EngineConfigForm';
import { TargetConfig } from '../watchfolder/Watchfolder.model';

interface IProps {
  onSubmit: Function;
}

let enginesRequestPending = false;
const pendingProfileRequests = new Set<string>();


export function FileConfigs({ onSubmit }: IProps) {

  // const [formData, setFormData] = React.useState<IFileQueuerConfig>(null);
  const fileQueuerConfigs = useAppSelector(selectFileQueuerTagetConfigs)
  const [targetConfig, setTagetConfig] = React.useState<TargetConfig>(fileQueuerConfigs?.config ?? {});
  const dispatch = useAppDispatch()
  const token = useAppSelector(selectToken)
  const engines = useAppSelector(selectWatchfolderEngines)
  const engineProfiles = useAppSelector(selectWatchfolderEngineProfiles)

  const handleChange = (field: keyof IFileQueuerConfig, value: any) => {
    dispatch(setFileQueuerTagetConfigs({
      ...fileQueuerConfigs,
      [field]: value
    }));
  };

  useEffect(() => {
    if (!token || engines.length > 0 || enginesRequestPending) return;
    enginesRequestPending = true;
    dispatch(getWatchfolderEngines({ token })).finally(() => {
      enginesRequestPending = false;
    });
  }, [dispatch, engines.length, token])

  useEffect(() => {
    const selectedEngineId = fileQueuerConfigs?.targetService;
    const selectedEngine = engines.find(
      engine => engine.id.toUpperCase() === selectedEngineId?.toUpperCase()
    );
    if (
      !token ||
      !selectedEngine?.configSchema?.profileEndpoint ||
      Object.prototype.hasOwnProperty.call(engineProfiles, selectedEngine.id) ||
      pendingProfileRequests.has(selectedEngine.id)
    ) return;

    pendingProfileRequests.add(selectedEngine.id);
    dispatch(getWatchfolderEngineProfiles({ token, engine: selectedEngine })).finally(() => {
      pendingProfileRequests.delete(selectedEngine.id);
    });
  }, [dispatch, engineProfiles, engines, fileQueuerConfigs?.targetService, token])

  useEffect(() => {
    dispatch(setFileQueuerTagetConfigs({
      ...fileQueuerConfigs,
      config: targetConfig
    }));
  }, [targetConfig]);

  // const handleConfigChange = (field: string, value: any) => {
  //     let targetConfig = { ...formData.targetService, [field]: value }
  //     setFormData({ ...formData, targetConfig });
  // };

  const handleOnClose = () => {
    handleChange('targetService', "")
  };

  const handleSubmit = () => {
    onSubmit(fileQueuerConfigs);
    handleOnClose();
  };

  if (!fileQueuerConfigs) return null

  return <div className="panel-content" style={{ }}>
    <Select
      id="task-system"
      labelText="Action"
      defaultValue={fileQueuerConfigs.targetService?.toUpperCase()}
      value={fileQueuerConfigs.targetService?.toUpperCase()}
      onChange={(e) => handleChange('targetService', e.target.value)}
    >
      <SelectItem text="Choose ..." value={""} />
      {engines?.length && engines.map(engine => <SelectItem key={engine?.id} text={engine?.label} value={engine?.id} />)}
    </Select>

    {fileQueuerConfigs?.targetService && fileQueuerConfigs?.targetService !== "" && <>

      <EngineConfigForm
        selectedEngine={fileQueuerConfigs.targetService?.toUpperCase()}
        formData={targetConfig}
        setFormData={setTagetConfig}
      />
      {/* <NumberInput id="retry" label="Retry Count" min={0} max={10} /> */}
      {/* <div style={{ display: "flex", flexDirection: "column", gap: 10, border: "1px solid #666", padding: 10, borderRadius: 5 }}>
        <Select id="mode" labelText="Mode" defaultValue="auto">
          <SelectItem text="Auto" value="auto" />
          <SelectItem text="Manual" value="manual" />
        </Select>
      </div> */}

      <div style={{ display: "flex", textAlign: "right" }}>
        <Button kind="danger" style={{ marginTop: '1rem' }} onClick={e => handleOnClose()}>
          Cancel
        </Button>
        <Button
          kind="primary"
          style={{ marginTop: '1rem' }}
          onClick={e => handleSubmit()}
        >
          Send to Queue <span> <Icon type='send' size={18} /></span>
        </Button>
      </div>
    </>}
  </div>
}

export default FileConfigs
